import React from "react";
import planingImg1 from "../../Assets/landingPage/frond_home_diverse_diy.webp";
import planingImg2 from "../../Assets/landingPage/frond_ventures_podcast_studio.webp";
import planingImg3 from "../../Assets/landingPage/frond_events_wedding.webp";
import planingImg4 from "../../Assets/landingPage/frond_escapes_holiday.webp";
import { Link } from "react-router-dom";

const Planing = () => {
  const cards = [
    {
      id: 1,
      name: "HOME",
      link: "/home",
      image: planingImg1,
      imagePosition: "left",
      title: "Your Home Renovation Journey Starts with frond Plan It, Build It",
      description1: "Outgrowing your home? Frond helps families plan for the future Dream bigger: Manage renovations and expansions seamlessly to create a space that grows with your family",
      description2: "Stay organised: Centralise plans, budgets, and contractor details for a stress-free project."
    },
    {
      id: 2,
      name: "VENTURES",
      link: "/ventures",
      image: planingImg2,
      imagePosition: "right",
      title: "From Idea to Reality, Plan Your Venture with frond",
      description1: "Turn your business ideas into reality with frond Plan like a pro: Organize your business ideas, track progress, and never miss a detail",
      description2: "Collaborate with ease: Share ideas, assign tasks, plan your marketing strategy and keep everyone on the same page."
    },
    {
      id: 3,
      name: "EVENTS",
      link: "/events",
      image: planingImg3,
      imagePosition: "left",
      title: "Turn event planning chaos into organised joy with frond",
      description1: "Turn event planning chaos into organised joy with frond",
      description2: "Are you or someone you know planning their wedding and want to ensure that everything comes together perfectly for the special day? Are you juggling your time between looking at venues, guest lists, sorting out the caterer, photographer and make up artist, and not enough time to looking for the perfect dress?"
    },
    {
      id: 4,
      name: "ESCAPES",
      link: "/escape",
      image: planingImg4,
      imagePosition: "right",
      title: "Planning adventures shouldn't be an adventure in itself",
      description1: "Simplify your travel planning with frond's task planning, Effortless task planning: Avoid conflicts! Frond helps create a task plan ensuring your dream itinerary fit",
      description2: "Build your perfect trip: Create a detailed itinerary with all the must-see towns and cities right within the app"
    }
  ];

  // Helper component for card layout
  const Card = ({ card }) => {
    const imageOnLeft = card.imagePosition === "left";
    
    return (
      <Link to={card.link} className="block group">
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 h-full">
          <div className={`flex flex-col md:flex-row ${imageOnLeft ? 'md:flex-row' : 'md:flex-row-reverse'} h-full`}>
            {/* Image Section */}
            <div className="md:w-1/2 overflow-hidden relative">
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
              <img
                src={card.image}
                alt={card.name}
                className="w-full h-80 md:h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
            </div>
            
            {/* Content Section */}
            <div className="md:w-1/2 p-8 lg:p-10 flex flex-col justify-center bg-gradient-to-br from-white to-gray-50">
              {/* Category Badge */}
              <div className="mb-4">
                <span className="inline-block px-3 py-1 bg-gradient-to-r from-orange-500 to-pink-500 text-white text-xs font-semibold tracking-wider rounded-full">
                  {card.name}
                </span>
              </div>
              
              {/* Title with attractive styling */}
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 leading-tight group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-orange-600 group-hover:to-pink-600 transition-all duration-300">
                {card.title}
              </h3>
              
              {/* Description with better readability */}
              <div className="space-y-3 text-gray-600">
                <p className="text-base leading-relaxed">
                  {card.description1}
                </p>
                <p className="text-base leading-relaxed">
                  {card.description2}
                </p>
              </div>
              
              {/* Read More Link with attractive arrow */}
              <div className="mt-6">
                <span className="inline-flex items-center gap-2 text-orange-500 font-semibold group-hover:gap-3 transition-all duration-300 cursor-pointer">
                  Read More
                  <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  };

  return (
    <section className="planing py-20 bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="container xl:px-20 px-6 mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-600">
            Explore Our Solutions
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-pink-500 mx-auto mt-4 rounded-full"></div>
        </div>

        {/* Cards Grid - Single column with alternating image positions */}
        <div className="flex flex-col gap-8 max-w-7xl mx-auto">
          {cards.map((card) => (
            <Card key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Planing;